import { render, staticRenderFns } from "./option.vue?vue&type=template&id=2b8635ae&scoped=true&"
import script from "./option.vue?vue&type=script&lang=js&"
export * from "./option.vue?vue&type=script&lang=js&"
import style0 from "./option.vue?vue&type=style&index=0&lang=css&"
import style1 from "./option.vue?vue&type=style&index=1&id=2b8635ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8635ae",
  null
  
)

export default component.exports